import { createFileRoute } from "@tanstack/react-router";
import { AbzugBremenPage } from "@/components/abzug-bremen/abzug-bremen-page";

export const Route = createFileRoute("/abzug-bremen/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AbzugBremenPage />;
}
